import { useInfiniteQuery } from 'react-query'
import {
    getMonyPoolsDetailLoans,
    TFundLoanSort,
    TFundLoanStatus,
} from 'services/fund'

export default function useGetLoans(
    id: string | undefined,
    searchLoans: string,
    sort?: TFundLoanSort,
    status: TFundLoanStatus = ''
) {
    const { data, isLoading, fetchNextPage, isError } = useInfiniteQuery(
        [
            'money-pools-fund-loans-infinite-loans',
            id,
            searchLoans,
            sort,
            status,
        ],
        ({ pageParam = 1 }) =>
            getMonyPoolsDetailLoans(pageParam, id, searchLoans, sort, status),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return { data, isLoading, fetchNextPage, isError }
}
